
import { defineMessages } from 'react-intl';

export default defineMessages({
    noToken: {
        id: 'ml.common.component.MLHOPropertyValuationComponent.No token to process',
        defaultMessage: 'No token to process'
    },
    sessionTimeout: {
        id: 'ml.common.component.MLHOPropertyValuationComponent.Session Timeout',
        defaultMessage: 'Session Timeout'
    }
});
